import React from 'react';
import { observer } from 'mobx-react';
import { styled } from '@this/constants/themes';
import { Box } from '@material-ui/core';
import { EmojiObjects } from '@material-ui/icons';
import { Modal, ModalBody, ModalFooter } from '@this/shared/ui/feedbacks/modal';
import { Button } from '@this/shared/ui/inputs/button';
import type OpenMeeting from '@this/domain/appoint/open_meeting';

interface Props {
  deleteTargetMeeting: OpenMeeting;
  onClose: () => void;
  onClickDelete: () => void;
}

const OpenMeetingDeleteModal = observer(({ deleteTargetMeeting, onClose, onClickDelete }: Props) => {
  return (
    <Modal open={deleteTargetMeeting !== null} size="medium" onClose={onClose}>
      <ModalBody>
        <Box display="flex" flexDirection="column" alignItems="center" style={{ color: '#243565' }}>
          <Icon />
          <Title>予定を削除する</Title>
          <SubTitle>下記のアイテムを削除します。</SubTitle>
        </Box>
        <MeetingBox>
          <Box fontWeight="bold">{deleteTargetMeeting.title}</Box>
          <Box marginTop="5px">{deleteTargetMeeting.duration}分</Box>
        </MeetingBox>
      </ModalBody>
      <Footer>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          style={{ width: '100%', padding: '8px 20px' }}
        >
          <FooterText>削除してもよろしいですか？</FooterText>
          <DeleteButton color="danger" onClick={onClickDelete}>
            削除
          </DeleteButton>
        </Box>
      </Footer>
    </Modal>
  );
});

const Icon = styled(EmojiObjects)`
  font-size: 3.5rem;
`;

const Title = styled.p`
  font-size: 1.8rem;
  font-weight: bold;
  margin: 0.5rem 0;
`;

const SubTitle = styled.p`
  font-size: 1rem;
  margin: 0;
`;

const MeetingBox = styled(Box)`
  margin: 1rem auto;
  border: 2px solid #f7f7f7;
  border-radius: 1px;
  padding: 1rem;
`;

const Footer = styled(ModalFooter)`
  background-color: #f7f7f7;
`;

const FooterText = styled.p`
  margin: 0;
  color: #7d7d7d;
  font-weight: bold;
`;

const DeleteButton = styled(Button)`
  background-color: #bf0000;
  color: #fff;

  &:hover {
    background-color: #bf0000;
  }
`;

export default OpenMeetingDeleteModal;
